import React from "react";
import { Button, HStack, Text } from "@chakra-ui/react";

const PaginationControls = ({ page = 1, pages = 1, onPageChange }) => (
  <HStack justify="flex-end" spacing={3}>
    <Button
      size="sm"
      variant="outline"
      isDisabled={page <= 1}
      onClick={() => onPageChange?.(page - 1)}
    >
      Previous
    </Button>
    <Text fontSize="sm" color="gray.500">
      Page {page} of {pages}
    </Text>
    <Button
      size="sm"
      variant="outline"
      isDisabled={page >= pages}
      onClick={() => onPageChange?.(page + 1)}
    >
      Next
    </Button>
  </HStack>
);

export default PaginationControls;
